import { type ComponentProps, type ReactElement } from 'react';
import cn from 'classnames';

import svgSprite from '@src/shared/assets/svg-sprite.svg';

import type { IconType } from './types';
import legacyStyles from './legacy.module.scss';

// TODO переехать на MaterialSymbols
const ICON_SIZES: Record<IconType, { width: number; height: number }> = {
  'legacy/minus': { width: 16, height: 16 },
  'legacy/numberMinus': { width: 16, height: 16 },
  'legacy/numberPlus': { width: 16, height: 16 },
  'legacy/clone': { width: 16, height: 16 },
  'legacy/done': { width: 16, height: 16 },
  'legacy/download': { width: 16, height: 16 },
  'legacy/downloadFile2': { width: 16, height: 16 },
  'legacy/edit': { width: 16, height: 16 },
  'legacy/error': { width: 16, height: 16 },
  'legacy/repeat': { width: 16, height: 16 },
  'legacy/shared': { width: 16, height: 16 },
  'legacy/shared_button': { width: 16, height: 16 },
  'legacy/wait': { width: 16, height: 16 },

  'legacy/orders': { width: 24, height: 24 },
  'legacy/exit': { width: 24, height: 24 },
  'legacy/back': { width: 24, height: 24 },
  'legacy/close': { width: 24, height: 24 },
  'legacy/burgerArrow': { width: 24, height: 24 },
  'legacy/executors': { width: 24, height: 24 },
  'legacy/expense': { width: 24, height: 24 },
  'legacy/reports': { width: 24, height: 24 },
  'legacy/workers': { width: 24, height: 24 },

  'legacy/engineer': { width: 20, height: 20 },
  'legacy/handshake': { width: 20, height: 20 },
  'legacy/help': { width: 20, height: 20 },

  'legacy/mygig-icon': { width: 18, height: 19 },
  'legacy/select': { width: 12, height: 10 },
  'legacy/question': { width: 6, height: 9 },
  'legacy/chevronDown': { width: 10, height: 6 },
  'legacy/faq': { width: 18, height: 18 },
  'legacy/reportsLetter': { width: 18, height: 18 },
  'legacy/mobile': { width: 12, height: 22 },
  'legacy/separator': { width: 12, height: 11 },
  'legacy/sorterDown': { width: 8, height: 5 },
  'legacy/sorterUp': { width: 8, height: 5 },
  'legacy/support': { width: 19, height: 18 },
  'legacy/telegram': { width: 19, height: 17 },
  'legacy/errorCircle': { width: 23, height: 23 },
  'legacy/rouble': { width: 24, height: 20 },
  'legacy/registries': { width: 24, height: 20 },

  'legacy/xlsxIcon': { width: 56, height: 56 },
  'legacy/xlsxIconDisabled': { width: 56, height: 56 },
  'legacy/registriesError': { width: 58, height: 61 },
  'legacy/registriesSuccess': { width: 59, height: 61 },

  'material-symbols/add': { width: 24, height: 24 },
  'material-symbols/arrow_back': { width: 24, height: 24 },
  'material-symbols/arrow_back-mobile': { width: 24, height: 24 },
  'material-symbols/arrow_back_ios_new': { width: 24, height: 24 },
  'material-symbols/arrow_forward_ios': { width: 24, height: 24 },
  'material-symbols/arrow_upward': { width: 24, height: 24 },
  'material-symbols/check': { width: 24, height: 24 },
  'material-symbols/close': { width: 24, height: 24 },
  'material-symbols/delete': { width: 24, height: 24 },
  'material-symbols/group': { width: 24, height: 24 },
  'material-symbols/ios_share': { width: 24, height: 24 },
  'material-symbols/keyboard_arrow_down': { width: 24, height: 24 },
  'material-symbols/keyboard_arrow_up': { width: 24, height: 24 },
  'material-symbols/lists': { width: 24, height: 24 },
  'material-symbols/menu': { width: 24, height: 24 },
  'material-symbols/page_info': { width: 24, height: 24 },
  'material-symbols/payments': { width: 24, height: 24 },
  'material-symbols/shield_person': { width: 24, height: 24 },
};

interface IconProps extends ComponentProps<'svg'> {
  name: IconType;
  size?: number;
}

const Icon = ({
  name,
  size = 24,
  height,
  width,
  className,
  ...rest
}: IconProps): ReactElement => {
  const isLegacy = name.startsWith('legacy/');

  const iconSizes = ICON_SIZES[name];
  const finalWidth = width ?? iconSizes?.width ?? size;
  const finalHeight = height ?? iconSizes?.height ?? size;

  return (
    <svg
      height={finalHeight}
      width={finalWidth}
      className={cn(className, {
        [legacyStyles.legacy]: isLegacy,
      })}
      data-icon={isLegacy ? name : undefined}
      preserveAspectRatio="xMidYMid meet"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      {...rest}
    >
      <use xlinkHref={`${svgSprite}#${name}`} width="100%" height="100%" />
    </svg>
  );
};

export default Icon;
